/* @flow */
/**
 * 提取422错误的message
 * 应用：一般用于提取message统一曝出
 * @param {原始数组 *} arr
 */
export function extract422Message(res422Data: Object = {}, field?: string): string {
  const errKeys = Object.keys(res422Data) || [];
  let errData: string[] = [];
  errKeys.forEach((key: string) => {
    if (!field) return errData = res422Data[key];
    if (key == field) return errData = res422Data[key];
  });
  console.log('errData', errData)
  return Array.isArray(errData) && errData[0] ? errData[0] : '表单填写存在错误';
}

/**
 * 处理er-form异步数据异常的数据管理对象
 * ******************************************
 * 作用：创建异常管理对象
 * 使用例子：this.asyncErrorStore = createErrorStore();
 * 使用场景：created时初始化该页面的异常对象，一般一个form需要创建一个异常对象，来对sync error进行管理。
 * ******************************************
 * 作用：绑定异常项目（el-form-item）
 * 使用例子：:rules="[{ validator: asyncErrorStore.rules, trigger: 'change'}]"
 * 使用场景：在vue template里指定哪个el-form-item需要进行sync校验，会自动取prop的value作为异常的key。
 * ******************************************
 * 作用：http返回422时，将异常项添加到异常对象中
 * 使用例子：
 *  if (res.code == 422) {
 *   this.asyncErrorStore.pushByRes(res);// 从res中提取异步表单异常数据，并添加到异常对象上
 *   this.$refs['nodeForm'].validate(); // 触发校验表单，异步异常会显示在页面上
 *   return;
 * }
 * 使用场景：在vue template里指定哪个el-form-item需要进行sync校验，会自动取prop的value作为异常的key。
 * ******************************************
 * 作用：清除指定key的异常数据
 * 使用例子：@change="asyncErrorStore.clear('propName')"
 * 使用场景：清理指定异常对象，一般在单个输入框change或blur事件时触发清理。
 * ******************************************
 * 作用：清空所有异常数据
 * 使用例子：his.asyncErrorStore.clearAll();
 * 一般在表单提交前，要先把所有异步异常清理掉，再进行提交，等请求回来后，再进行二次
 */
export function createErrorStore() {
  const errorContainer: Object = Object.create(null);

  /**
   * 删除所有的error对象
   */
  const clearAll = (): void => {
    const keys = Object.keys(errorContainer);
    for (const key of keys) {
      delete errorContainer[key];
    }
  };

  /**
   * 删除指定filed的error对象
   * @param {*} field 
   */
  const clear = (field: string): void => {
    if (!errorContainer[field]) return;
    delete errorContainer[field];
  };

  /**
   * 添加error对象
   * @param {*} field 
   * @param {*} message 
   */
  const push = (field: string, message: string): void => {
    errorContainer[field] = message;
  };

  /**
   * 添加error对象存储，通过axios res
   * @param {*} res 
   */
  const pushByRes = (res: Res): void => {
    const errorBody = res.data || {};
    for (const field in errorBody) {
      const message = extract422Message(errorBody, field);
      if (!message) continue;
      push(field, message);
    }
  };

  const getStore = () => {
    return errorContainer;
  };

  const logStore = (): void => {
    console.log(JSON.stringify(2, null, errorContainer));
  };

  return {
    rules(rule: any, value: any, callback: Function) {
      const field = rule.field;
      const message = errorContainer[field];
      if (message) return callback(new Error(message));
      callback();
    },
    clearAll,
    clear,
    push,
    pushByRes,
    getStore,
    logStore
  };
}
